// extracted by mini-css-extract-plugin
module.exports = {"header":"wLE4r","logo":"he+7C","nav-item":"pn-Pk"};